import { COMPLIANCE_DOCUMENTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/compliance_documents_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'supplierComplianceDocumentsIndex',
	'linkDocumentCandidates',
	'complianceClientsDropdown',
	// Backs the supplier Overview "Document" async-select filter. Seeded so
	// getRecordsForTargetCollection doesn't throw on first render.
	'complianceOverviewDocumentFilter',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
